module.exports = "<p>\r\n  cyber-pay-verify works!\r\n</p>\r\n"